'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./profile/profile'));
    processInclude(require('./components/passwordToggle'));
});
